var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManWithCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 281,
    viewBox: "0 0 226 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_27891)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.828 276.814C117.553 276.814 127.058 275.408 127.058 273.673C127.058 271.938 117.553 270.532 105.828 270.532C94.1029 270.532 84.5979 271.938 84.5979 273.673C84.5979 275.408 94.1029 276.814 105.828 276.814Z",
    fill: "#A68EB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.3927 276.814C85.1177 276.814 94.6227 275.408 94.6227 273.673C94.6227 271.938 85.1177 270.532 73.3927 270.532C61.6678 270.532 52.1628 271.938 52.1628 273.673C52.1628 275.408 61.6678 276.814 73.3927 276.814Z",
    fill: "#A68EB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.4693 281.112C121.637 281.112 155.01 277.667 155.01 273.418C155.01 269.168 121.637 265.723 80.4693 265.723C39.3017 265.723 5.92871 269.168 5.92871 273.418C5.92871 277.667 39.3017 281.112 80.4693 281.112Z",
    fill: "#CEBADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2561 188.501V263.322H116.64L126.389 181.65L42.2561 188.501Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2666 270.533L98.2245 209.955",
    stroke: "white",
    strokeWidth: 1.89218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.463 261.881C64.463 261.881 62.2965 270.715 62.8381 272.698C63.3798 274.501 68.9766 271.797 68.9766 271.797L74.2123 273.419H91.5445C91.5445 273.419 94.6137 267.65 85.9477 267.65L77.1011 265.487V261.881H64.463Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7946 262.961C94.7946 262.961 92.9892 270.894 93.5308 272.697C93.8919 274.319 98.586 271.975 98.586 271.975L102.919 273.418H117.182C117.182 273.418 119.71 268.189 112.668 268.189L105.447 266.386V263.141H94.7946V262.961Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.293 84.8133C189.293 84.8133 191.494 133.966 139.756 149.827L119.942 125.486C119.942 125.486 167.906 83.0859 169.95 75.7051L189.293 84.8133Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4051 104.131C70.4051 104.131 24.6428 128.158 24.3283 149.829C24.0138 171.5 37.6953 185.32 75.7518 187.99L76.8526 167.574L58.7679 132.084L79.3688 116.694L70.4051 104.131Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1467 188.146C30.1467 188.146 47.2879 122.19 78.8969 107.585C110.506 92.9807 121.199 113.71 121.199 113.71C121.199 113.71 144.945 117.008 143.373 154.226C141.8 191.444 132.522 209.032 132.522 209.032L30.1467 188.146Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.95 124.231L129.692 145.903L121.671 205.106L84.0867 198.197L109.248 147.787L105.159 126.587L130.95 124.231Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.54745,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.18 130.669L115.853 143.232L80.4697 187.36L83.4576 201.807L102.8 193.484L121.357 141.819L126.389 126.586L113.18 130.669Z",
    fill: "#EA4D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8124 157.994C60.8124 157.994 72.4495 155.481 72.6068 158.465C72.764 161.292 70.7197 163.176 67.1027 164.119C63.3285 165.218 57.8245 163.647 57.8245 163.647L60.8124 157.994Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 3.14104,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2196 172.442C48.0744 178.409 55.151 185.79 62.0704 185.633C68.9898 185.476 74.6511 179.98 74.4938 173.227C74.3366 166.474 68.6753 160.978 61.7559 161.135C56.2518 161.135 54.3647 166.474 51.2196 172.442Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.34769,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9697 176.995L68.8327 181.706",
    stroke: "#020203",
    strokeWidth: 2.58941,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4854 170.243L73.3926 176.368",
    stroke: "#020203",
    strokeWidth: 2.58941,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.784 92.6668L161.929 58.4323C161.929 58.4323 176.397 40.687 177.026 37.5462C177.655 34.4054 211.151 64.5569 217.913 77.434L197.784 92.6668Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.96756,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.756 41.9424L174.982 47.1247L182.059 54.3484L187.405 48.538C187.405 48.538 182.216 43.1987 178.756 41.9424Z",
    stroke: "#9D9D9C",
    strokeWidth: 1.4868,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.967 57.3212C193.229 55.85 191.438 55.2553 189.967 55.9929C188.496 56.7305 187.901 58.5211 188.639 59.9924C189.376 61.4636 191.167 62.0583 192.638 61.3207C194.109 60.5831 194.704 58.7925 193.967 57.3212Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 0.508297,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.308 65.6833C193.308 65.6833 191.256 63.15 192.046 61.7117C192.911 60.1867 194.359 58.8634 194.359 58.8634C194.359 58.8634 197.258 58.4918 198.494 59.8651L193.394 65.7583L193.308 65.6833Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.819 58.2259C190.294 58.8325 190.294 58.8325 190.069 59.0925C188.633 60.5775 190.458 61.0958 190.071 61.3675C189.759 61.5525 188.979 60.8775 188.633 60.5775C187.766 59.8275 187.921 58.5975 187.984 58.3492C188.214 57.0326 189.138 56.3159 189.288 56.1426C190.061 55.5993 190.869 55.5409 191.031 55.5293C192.001 55.4593 192.758 55.8109 193.018 56.0359C193.699 56.4742 193.821 57.0342 193.746 57.1209C193.671 57.2076 193.289 56.4226 192.481 56.4809C192.158 56.5042 191.933 56.7642 191.621 56.9492C191.246 57.3826 191.344 57.6192 190.819 58.2259Z",
    fill: "#F22165"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.051 57.3789C193.313 55.9076 191.522 55.3129 190.051 56.0505C188.58 56.7881 187.985 58.5787 188.723 60.05C189.46 61.5212 191.251 62.1159 192.722 61.3783C194.193 60.6407 194.788 58.8501 194.051 57.3789Z",
    stroke: "#1D1D1B",
    strokeWidth: 0.508297,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.371 52.377L185.063 58.2932L193.142 66.54L199.246 59.9067C199.246 59.9067 193.321 53.8112 189.371 52.377Z",
    stroke: "#9D9D9C",
    strokeWidth: 1.69737,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.297 51.8369L169.321 60.317L171.208 61.8874L177.813 54.3495L175.297 51.8369Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.547 59.458L176.571 67.9381L178.458 69.5085L185.063 61.9706L182.547 59.458Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.405 64.9922L181.429 73.4723L183.317 75.0427L189.921 67.5048L187.405 64.9922Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.376 62.2002L187.625 78.8125L189.562 80.875L204.892 64.7128L202.376 62.2002Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.071 48.8514C179.071 48.8514 180.014 48.5373 181.901 49.1655C181.901 49.1655 179.071 40.8424 181.43 39.7432",
    stroke: "#13A538",
    strokeWidth: 1.4868,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0379 72.7224C53.1065 100.047 73.0783 124.388 101.385 128.471C129.849 132.554 155.954 115.123 159.885 87.6411C163.816 60.1593 144.159 34.7191 115.695 30.6361C87.2316 26.5531 61.1267 45.3977 57.0379 72.7224Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 3.65016,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.555 82.3019C140.681 82.3019 143.216 79.7708 143.216 76.6485C143.216 73.5262 140.681 70.9951 137.555 70.9951C134.428 70.9951 131.893 73.5262 131.893 76.6485C131.893 79.7708 134.428 82.3019 137.555 82.3019Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.735239,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 76.6487C158.949 76.6487 160.357 75.2426 160.357 73.508C160.357 71.7734 158.949 70.3672 157.212 70.3672C155.475 70.3672 154.067 71.7734 154.067 73.508C154.067 75.2426 155.475 76.6487 157.212 76.6487Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.407587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.228 67.5403C140.228 67.5403 136.454 65.1847 133.151 68.0114",
    stroke: "black",
    strokeWidth: 1.03965,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.829 70.3672C160.829 70.3672 158.47 67.2264 155.482 67.8545",
    stroke: "black",
    strokeWidth: 0.791606,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2762 88.2692C50.2762 88.2692 59.2399 93.9226 66.3165 87.7981C73.3932 81.6736 61.2843 74.7639 73.5504 69.5816C73.5504 69.5816 88.3327 73.3506 94.7803 53.8778C94.7803 53.8778 95.5666 46.654 110.821 50.58C126.075 54.5059 117.583 57.1756 117.583 57.1756C117.583 57.1756 128.119 62.829 134.252 52.6215L133.623 57.3326C133.623 57.3326 138.813 60.0023 145.732 51.5222L145.889 55.6052C145.889 55.6052 149.506 54.977 149.506 46.497C149.506 38.0169 123.244 23.4123 104.688 26.0819C86.1311 28.7516 67.8891 36.2894 60.1835 52.7785C60.1835 52.7785 58.9254 58.1178 51.8488 58.4319C51.8488 58.4319 50.7479 59.5312 57.3528 60.9445C57.3528 60.9445 50.1189 65.1846 46.8165 62.6719C46.8165 62.6719 45.4011 67.5401 54.9939 66.912C54.9939 66.912 54.3649 73.9787 48.5463 74.4498C48.5463 74.4498 49.9616 76.6484 52.635 78.2188C52.635 78.2188 51.377 85.1285 46.8165 85.1285C41.9415 84.9714 50.2762 88.2692 50.2762 88.2692Z",
    fill: "#4D3280"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.0379 72.7224C53.1065 100.047 73.0783 124.388 101.385 128.471C129.849 132.554 155.954 115.123 159.885 87.6411C163.816 60.1593 144.159 34.7191 115.695 30.6361C87.2316 26.5531 61.1267 45.3977 57.0379 72.7224Z",
    stroke: "#020203",
    strokeWidth: 3.65016,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.377 96.7494C129.691 97.3776 130.163 98.0057 130.635 98.6339C131.107 99.2621 131.736 99.7332 132.207 100.361C133.308 101.304 134.724 102.089 136.296 102.403C136.768 102.403 136.925 102.874 136.925 103.345C136.925 103.659 136.453 103.973 136.139 103.973C134.252 103.816 132.522 103.188 131.107 102.089C130.32 101.618 129.691 100.989 129.062 100.361C128.433 99.7332 127.804 99.105 127.332 98.3198C126.861 97.6917 127.018 96.9065 127.647 96.5924C128.119 95.8072 128.905 95.9642 129.377 96.7494C129.377 96.5924 129.377 96.5924 129.377 96.7494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.655 74.2931C178.599 73.5079 180.014 72.2516 180.8 70.6812C182.216 67.3834 181.901 64.0855 180.014 63.1433C178.127 62.2011 175.454 64.2426 173.881 67.3834C173.252 68.7967 173.095 69.896 173.095 71.1523V71.6234C173.567 76.0205 173.724 78.8472 177.655 82.4591C180.171 84.6576 181.115 84.9717 183.474 85.2858C183.474 85.2858 185.361 85.4428 189.135 84.8147L179.7 74.9212",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.655 74.2931C178.599 73.5079 180.014 72.2516 180.8 70.6812C182.216 67.3834 181.901 64.0855 180.014 63.1433C178.127 62.2011 175.454 64.2426 173.881 67.3834C173.252 68.7967 173.095 69.896 173.095 71.1523V71.6234C173.567 76.0205 173.724 78.8472 177.655 82.4591C180.171 84.6576 181.115 84.9717 183.474 85.2858C183.474 85.2858 185.361 85.4428 189.135 84.8147L179.7 74.9212",
    stroke: "#020203",
    strokeWidth: 1.96756,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_27891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224.944,
    height: 280,
    fill: "white",
    transform: "translate(0.424805 0.956055)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManWithCard);
export default __webpack_public_path__ + "static/media/man-with-card.d539aa6fb0a17001252303d202126bbd.svg";
export { ForwardRef as ReactComponent };